import { useInView } from '../../../hooks/useInView';

const stats = [
  { value: '12+', label: 'Anos de Experiência' },
  { value: '200+', label: 'Produtos Premium' },
  { value: '500K+', label: 'Clientes Satisfeitas' },
  { value: '50+', label: 'Reviews positivos' },
];

export default function AboutSection() {
  const { ref, inView } = useInView();

  return (
    <section id="sobre" className="py-24 bg-[#0F7C7A]">
      <div ref={ref} className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className={`relative ${inView ? 'animate-fade-in-left' : 'opacity-0-init'}`}>
            <div className="relative w-full h-[560px] rounded-3xl overflow-hidden">
              <img
                src="https://storage.readdy-site.link/project_files/bc073682-be8a-41b0-bc42-811cad36305d/e4398052-3ebe-4939-a599-11d9c568549b_unnamed-1.jpg?v=af647752593581e7e1ff8346c3009086"
                alt="Sobre a marca"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A5F5C]/20 to-transparent" />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-6 bg-white rounded-2xl p-5 border border-[#C8E8E8] w-48">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 flex items-center justify-center bg-[#E0F5F5] rounded-full">
                  <i className="ri-award-fill text-[#0F7C7A] text-lg" />
                </div>
                <div>
                  <p className="text-[#1A1A1A] font-bold text-sm">Premiada</p>
                  <p className="text-[#555555] text-xs">2024</p>
                </div>
              </div>
              <p className="text-[#555555] text-xs leading-snug">
                Marca de cosméticos mais bem avaliada por clientes
              </p>
            </div>
            {/* Decorative */}
            <div className="absolute -top-6 -left-6 w-24 h-24 rounded-full border-2 border-white/30" />
            <div className="absolute top-12 -left-3 w-12 h-12 rounded-full bg-white/10" />
          </div>

          {/* Text */}
          <div className={`${inView ? 'animate-fade-in-right' : 'opacity-0-init'}`}>
            <p className="text-[#7FCECC] text-sm font-semibold tracking-[0.2em] uppercase mb-3">
              Nossa História
            </p>
            <h2 className="font-display text-4xl lg:text-5xl text-white font-bold leading-tight mb-6">
              Beleza com{' '}
              <span className="italic text-[#7FCECC]">Propósito</span>{' '}
              e Ciência
            </h2>
            <p className="text-white/75 leading-relaxed mb-5 text-base">
              Fundada em 2009, nascemos com a missão de transformar a rotina de beleza das mulheres brasileiras através de cosméticos de alta performance com ingredientes naturais e sustentáveis.
            </p>
            <p className="text-white/75 leading-relaxed mb-8 text-base">
              Cada produto é fruto de anos de pesquisa e desenvolvimento, combinando a riqueza da biodiversidade brasileira com tecnologia de ponta. Nossa equipe de especialistas garante que cada fórmula seja segura, eficaz e incrível.
            </p>

            {/* Values */}
            <div className="flex flex-wrap gap-3 mb-10">
              {['100% Natural', 'Cruelty Free', 'Vegano', 'Sustentável'].map((tag) => (
                <span
                  key={tag}
                  className="bg-white/10 border border-white/20 text-white text-xs font-semibold px-4 py-2 rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="bg-white/10 rounded-2xl p-5 border border-white/10">
                  <div className="font-display text-3xl font-bold text-[#7FCECC] mb-1">
                    {stat.value}
                  </div>
                  <div className="text-white/70 text-sm">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
